<template >
  <table class="table_01 margin_01 ">
    <tr>
      <th>名前</th>
      <td>{{ values.name }}</td>
    </tr>
    <tr>
      <th>ふりがな</th>
      <td>{{ values.kana }}</td>
    </tr>
    <tr>
      <th>社名</th>
      <td>{{ values.company }}</td>
    </tr>
    <tr>
      <th>メールアドレス</th>
      <td>{{ values.mailaddress }}</td>
    </tr>
    <tr class="br_">
      <th>問い合わせ件名</th>
      <td>{{ values.title }}</td>
    </tr>
    <tr class="br_">
      <th>問い合わせ内容</th>
      <td>{{ values.contactBody }}</td>
    </tr>
  </table>
</template>


<script>

export default {
  computed: {
    agreement() {
      return this.values.agree ? "同意する" : "同意しない";
    },
    values() {
      return this.$store.getters["contact/values"];
    }
  }
};
</script>

<style scoped>
.margin_01 {
  margin-bottom: 30px !important;
  margin-left: 200px;
}

/**問い合わせ内容の表示方法を指定
 */
table.table_01 tr.br_ td:nth-child(2) {
  width: 600.156px !important;
  word-break: break-all;
  /* 長いテキストの折り返しに必要 */
  white-space: pre-wrap;
  /* 行の折り返しに必要 */
}
</style>
